var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76025 15.8727L11.1857 10.9195C12.2806 9.75948 12.9522 8.19568 12.9522 6.4761C12.9522 2.90156 10.0505 0 6.4761 0C2.90166 0 0 2.90166 0 6.4761C0 8.19575 0.671545 9.75938 1.76647 10.9195L6.19195 15.8727C6.26427 15.954 6.36759 16 6.47614 16C6.58468 16 6.688 15.954 6.76032 15.8727H6.76025ZM6.47607 3.80964C5.00452 3.80964 3.80935 5.00469 3.80935 6.47623C3.80935 7.94791 5.00452 9.14295 6.47607 9.14295C7.94761 9.14295 9.14278 7.94791 9.14278 6.47623C9.14278 5.00469 7.94761 3.80964 6.47607 3.80964Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7d78bcb23bda5d0093225488915dcf81.svg";
export { ForwardRef as ReactComponent };